var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import styles from "./QuestionList.module.scss";
import { FormSelect } from "react-bootstrap";
import { currentSessionId, sendMessage, setIsUserResponseLoading } from "../../stores/reducers/chatReducer";
import chatBotApi from "../../api/chatbot";
import { useDispatch, useSelector } from "react-redux";
import { getSettings, getTranslation } from "../../constants/setting";
import { forEach } from "lodash";
import { MESSAGE_TYPE_CATEGORY } from "../../constants";
import { isLanguageRTL } from "../../../../constants";
var QuestionList = function (props) {
    var dispatch = useDispatch();
    var sessionId = useSelector(currentSessionId);
    var _b = useState(''), selected = _b[0], setSelected = _b[1];
    var _j = getSettings(), language = _j.language, current_page_url = _j.current_page_url;
    var questions = props.questions, category = props.category;
    var sendInquiry = function (e) {
        var text = e.target.value;
        if (text) {
            dispatch(sendMessage({ send: text }));
            dispatch(setIsUserResponseLoading(true));
            chatBotApi.postSendMessage(sessionId, text, current_page_url).then(function (response) {
                forEach(response.data, function (value, key) {
                    dispatch(sendMessage({
                        response: value
                    }));
                });
            }).catch(function (err) {
                console.error(err);
                console.log(err);
            }).finally(function () {
                dispatch(setIsUserResponseLoading(false));
                setTimeout(function () {
                    dispatch(sendMessage({
                        response: {
                            type: MESSAGE_TYPE_CATEGORY,
                            language: language,
                            data: {
                                showCategories: true
                            }
                        }
                    }));
                }, 1000);
            });
        }
        setSelected(text);
    };
    return _jsxs("div", __assign({ className: "".concat(styles.questionWrapper, " ").concat(isLanguageRTL(language) && styles.rtl) }, { children: [_jsxs("h5", __assign({ className: styles.heading }, { children: [category, " ", getTranslation('chatbot.questions'), ":"] })), _jsx("div", __assign({ className: styles.questionList }, { children: _jsxs(FormSelect, __assign({ onChange: sendInquiry, value: selected }, { children: [_jsx("option", __assign({ value: "" }, { children: getTranslation('chatbot.select_question') }), 'question'), questions === null || questions === void 0 ? void 0 : questions.map(function (text, index) {
                            return _jsx("option", __assign({ value: text }, { children: text }), 'question' + index);
                        })] })) }))] }));
};
export default QuestionList;
